module.exports = __webpack_public_path__ + "img/Groups.8c5c938a.svg";